import React, { useState } from 'react';

import RecipeValidator from 'domain/recipe/usecases/validator';

import Step from 'components/stepper/Step';
import EditSingleFormPage from 'components/form/EditSingleFormPage';
import mapStepToInput from 'components/recipes/steps/mapStepToInput';

const RecipeEditSingleFormPageStep = ({
  onBackButtonClick,
  stepTitle,
  spacing,
  recipeContent,
  setRecipe,
  step,
  onInputSubmit,
}) => {
  const [savedRecipe] = useState(recipeContent);

  const _onBackButtonClick = () => {
    setRecipe({ ...recipeContent, [step]: savedRecipe[step] });
    onBackButtonClick();
  };

  return (
    <Step
      stepTitle={stepTitle}
      spacing={spacing}
      onBackButtonClick={_onBackButtonClick}
      renderBody={() => {
        return (
          <EditSingleFormPage
            Input={mapStepToInput(step)}
            submitButtonLabel="CONFIRM"
            inputValue={recipeContent[step]}
            validator={RecipeValidator[step]}
            onInputChange={(value) =>
              setRecipe({
                ...recipeContent,
                [step]: value,
              })
            }
            onInputSubmit={onInputSubmit}
          ></EditSingleFormPage>
        );
      }}
    ></Step>
  );
};

export default RecipeEditSingleFormPageStep;
